import { IndicatorsContainer, SelectContainer, ValueContainer } from './containers';
import Control from './control';
import Group, { GroupHeading } from './group';
import { ClearIndicator, CrossIcon, DownChevron, DropdownIndicator, IndicatorSeparator, LoadingIndicator } from './indicators';
import Input from './input';
import Menu, { LoadingMessage, MenuList, MenuPortal, NoOptionsMessage } from './menu';
import MultiValue, { MultiValueContainer, MultiValueLabel, MultiValueRemove } from './multi-value';
import Option from './option';
import Placeholder from './placeholder';
import SingleValue from './single-value';
export const components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
export const defaultComponents = props => ({
  ...components,
  ...props.components
});